import type { useTranslations } from 'next-intl';
import type { AeDeliveryWindow } from './deliveryWindow';

// Narrowed to the 'ring' namespace (not a generic `(key: string) => string`)
// so passing a translator bound to the wrong namespace — e.g. BottomBarAlternate's
// `t` (namespace 'common') instead of its `tRing` — fails typecheck instead of
// silently falling through to a missing-key string at runtime.
type RingTranslator = ReturnType<typeof useTranslations<'ring'>>;

/** Literal keys per branch, not a lookup table — check-i18n-keys only sees
 * quoted first args to t(), same constraint as useSddNddEligibility.ts. */
export const aeDeliveryEtaCopy = (
  deliveryWindow: AeDeliveryWindow,
  t: RingTranslator,
): string => {
  if (deliveryWindow === 'four_hour') {
    return t('ring.aeDelivery.arrivesInFourHours');
  }
  if (deliveryWindow === 'next_day') {
    return t('ring.aeDelivery.arrivesTomorrow');
  }
  return t('ring.aeDelivery.arrivesToday');
};

/** Composed copy for every surface except the bottom bars (short ETA only,
 * space-constrained) — including the card title. e.g. "Arrives in 4 hours
 * across Dubai and Abu Dhabi". */
export const aeDeliveryEtaInlineCopy = (
  deliveryWindow: AeDeliveryWindow,
  t: RingTranslator,
): string =>
  `${aeDeliveryEtaCopy(deliveryWindow, t)} ${t(
    'ring.aeDelivery.acrossDubaiAbuDhabiInline',
  )}`;
